import React, {ChangeEvent, useRef} from "react";
import type {IGridSchemaFilesCell} from "ts/api/grid-schema";
import FlexBox from "view/components/Layout/FlexBox";
import {Box, Button, Tooltip, Typography} from "@material-ui/core";
import {grey} from "@material-ui/core/colors";
import InfoIcon from "@material-ui/icons/InfoOutlined";
import {UploadIcon} from "view/components/TaskDrawer/icons";
import {T} from "@tolgee/react";
import useStyles from "../styles";

type FileUploadButtonProps = {
  disabled?: boolean;
  viewMode?: boolean;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  fileSizeLimit?: number | null;
} & Pick<IGridSchemaFilesCell, "fileTypes" | "maxNumberOfFiles">;

const FileUploadButton = ({
  disabled,
  onChange = () => null,
  maxNumberOfFiles,
  fileSizeLimit,
  fileTypes,
  viewMode,
}: FileUploadButtonProps) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const safeFileTypes = fileTypes ?? [];
  const accept = safeFileTypes.join(",");
  const supportedFormats = safeFileTypes
    .map((type) => type.replace(".", "").toUpperCase())
    .join(", ");
  const classes = useStyles();

  return (
    <FlexBox alignCenter gap={1} width="100%" justifyContent="space-between">
      <FlexBox alignCenter gap={0.5}>
        <UploadIcon height={16} width={16} color={grey["500"]} />
        <Button
          className={classes.button}
          disabled={disabled}
          onClick={() => fileInputRef.current?.click()}
        >
          <Typography variant="h5" className={classes.mainText}>
            <T keyName="common.tasks.grid.cell.file_upload" />
          </Typography>
          <input
            type="file"
            accept={accept}
            multiple
            style={{display: "none"}}
            onChange={onChange}
            ref={fileInputRef}
          />
        </Button>
        {!viewMode && (
          <Tooltip
            title={
              <Box>
                <Typography className={classes.tooltipText}>
                  <T
                    keyName="common.tasks.grid.cell.format_hint"
                    params={{supportedFormats}}
                  />
                </Typography>
                {fileSizeLimit && (
                  <Typography className={classes.tooltipText}>
                    <T
                      keyName="common.tasks.grid.cell.max_size_hint"
                      params={{fileSizeLimit}}
                    />
                  </Typography>
                )}
                <Typography className={classes.tooltipText}>
                  <T
                    keyName="common.tasks.grid.cell.max_files_hint"
                    params={{maxNumberOfFiles}}
                  />
                </Typography>
              </Box>
            }
          >
            <InfoIcon htmlColor={grey["500"]} className={classes.icon} />
          </Tooltip>
        )}
      </FlexBox>
    </FlexBox>
  );
};
export default FileUploadButton;
